<template>
  <div class="retailer-search-type-options-fi">
    <div class="retailer-search-type-options-fi__container">
      <div
        v-for="element in clonedElements"
        :key="element.name"
        :class="{
          'retailer-search-type-options-fi__option': true,
          'retailer-search-type-options-fi__option--active': element.selected,
        }"
      >
        <checkbox-fi
          ref="input"
          v-model="element.selected"
          class="retailer-search-type-options-fi__checkbox checkbox-fi--label-normal checkbox-fi--no-margin"
          :disabled="element.disabled"
          :variant="element.disabled ? 'disabled' : null"
          :name="element.key || element.name"
          @update:model-value="(val) => checkBoxChanged(val, element)"
        >
          {{ element.name }} <span class="count">({{ element.count }})</span>
        </checkbox-fi>

        <template v-if="element.subElements">
          <div
            v-for="subElement in element.subElements"
            :key="subElement.name"
            :class="{
              'retailer-search-type-options-fi__suboption': true,
              'retailer-search-type-options-fi__suboption--active': subElement.selected,
            }"
          >
            <checkbox-fi
              ref="input"
              v-model="subElement.selected"
              class="retailer-search-type-options-fi__checkbox checkbox-fi--label-normal checkbox-fi--no-margin"
              :disabled="subElement.disabled"
              :variant="subElement.disabled ? 'disabled' : null"
              :name="subElement.key || subElement.name"
              @update:model-value="(val) => checkBoxChanged(val, element, subElement)"
            >
              {{ subElement.name }} <span class="count">({{ subElement.count }})</span>
            </checkbox-fi>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckboxFi } from 'atoms';

export default {
  name: 'RetailerSearchTypeOptionsFi',
  components: {
    CheckboxFi,
  },
  props: {
    elements: {
      type: Array,
      default: null,
    },
    partners: {
      type: Array,
      default: null,
    },
    retailers: {
      type: Array,
      default: null,
    },
  },
  emits: ['select-changed'],
  data() {
    return {
      clonedElements: null,
      activePartners: this.partners,
      activeRetailers: this.retailers,
    };
  },
  created() {
    this.clonedElements = JSON.parse(JSON.stringify(this.elements));
  },
  methods: {
    checkBoxChanged(value, element, subElement) {
      if (value && subElement && !element.selected) {
        this.clonedElements.find((el) => el === element).selected = true;
      } else if (!value && !subElement && element.subElements.length) {
        this.clonedElements.forEach((el) => {
          el.subElements.forEach((subEl) => {
            subEl.selected = false;
          });
        });
      }

      if (value) {
        if (subElement) {
          if (subElement.type === 'partner') {
            if (!this.activePartners.find((el) => el.name === subElement.name)) {
              this.activePartners.push(subElement);
            }

            if (element.type === 'retailer') {
              this.activeRetailers = this.activeRetailers.filter((el) => el.name !== element.name);
              this.activeRetailers.unshift(element);
            } else if (!this.activePartners.find((el) => el.name === element.name)) {
              this.activePartners.push(element);
            }
          } else if (!this.activeRetailers.find((el) => el.name === subElement.name)) {
            this.activeRetailers.push(subElement);
          }
        } else if (element.type === 'partner') {
          if (!this.activePartners.find((el) => el.name === element.name)) {
            this.activePartners.push(element);
          }
        } else if (!this.activeRetailers.find((el) => el.name === element.name)) {
          this.activeRetailers.push(element);
        }
      } else if (subElement) {
        if (subElement.type === 'partner') {
          this.activePartners = this.activePartners.filter((el) => el.name !== subElement.name);
        } else {
          this.activeRetailers = this.activeRetailers.filter((el) => el.name !== subElement.name);
        }
      } else {
        if (element.type === 'partner') {
          this.activePartners = this.activePartners.filter((el) => el.name !== element.name);
        } else {
          this.activeRetailers = this.activeRetailers.filter((el) => el.name !== element.name);
        }

        if (element.subElements?.length) {
          element.subElements.forEach((subEl) => {
            if (subEl.type === 'partner') {
              this.activePartners = this.activePartners.filter((el) => el.name !== subEl.name);
            } else {
              this.activeRetailers = this.activeRetailers.filter((el) => el.name !== subEl.name);
            }
          });
        }
      }

      this.$emit('select-changed', {
        newElements: this.clonedElements,
        activePartners: this.activePartners,
        activeRetailers: this.activeRetailers,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import './retailer-search-type-options-fi';
</style>

<style lang="scss">
@import './retailer-search-type-options-fi-unscoped';
</style>
